<template>
  <a-card :bordered="false">
    <a-form class="m-form" :form="form">
      <a-row type="flex" justify="start" align="top" :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Nama Sekolah / Universitas">
            <a-select v-decorator="[ 'sekolah', { rules: [{ required: true, validator:validateSekolah }], initialValue: initial.sekolah }]"
              show-search :filter-option="filterOption" allowClear mode="tags" :maxTagCount="1" :maxTagTextLength="45"
              @select="selectSekolah"
              >
              <a-select-option v-for="item in datamaster.sekolah" :key="item.id_sekolah">{{item.nama_sekolah}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Alamat">
            <a-input
              autocomplete="off"
              v-decorator="['alamat', {rules: [{required: true}], initialValue: initial.alamat}]"
              :disabled="isDisabledAlamatNoTelp"
            />
          </a-form-item>
          <a-form-item label="No. Telp">
            <a-input
              autocomplete="off"
              v-decorator="[
                'noTelp',
                { rules: [{ required: false }], initialValue: initial.no_telp }
              ]"
              @keydown="onlyNumber"
              :disabled="isDisabledAlamatNoTelp"
            >
              <a-select
                slot="addonBefore"
                v-decorator="['noTelp_code', { initialValue: '62' }]"
                style="width: 70px"
              >
                <a-select-option key="62" value="62" :disabled="isDisabledAlamatNoTelp">+62</a-select-option>
                <a-select-option key="61" value="61" :disabled="isDisabledAlamatNoTelp">+61</a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Guru / Dosen Pengantar">
            <a-input autocomplete="off" v-decorator="['guru', {rules: [{ required: true }], initialValue: initial.no_npwp }]" />
          </a-form-item>
          <a-row type="flex" :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Kelas / Jenjang">
                <a-input
                  autocomplete="off"
                  :maxLength="4"
                  v-decorator="['jenjang', {rules: [{required: true}], initialValue: initial.tahun_lulus}]"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Jurusan">
                <a-input
                  autocomplete="off"
                  :maxLength="4"
                  v-decorator="['jurusan', {rules: [{required: true}], initialValue: initial.tahun_lulus}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item v-if="mode === 'create'" label="Dokumen Pendukung">
            <a-upload
              class="d-block"
              accept="*"
              :showUploadList="true"
              :fileList="document"
              listType="text"
              :beforeUpload="beforeUpload"
              v-decorator="[
                'doc',
                { rules: [{ required: true }] },
                { valuePropName: 'push' }
              ]"
            >
              <a-button>
                <a-icon type="upload" />&nbsp; Select File
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import _ from "lodash";
export default {
  name: "document",
  props: ["collectedData", "mode", "datamaster"],
  data() {
    return {
      document: [],
      isDisabledAlamatNoTelp: false
    };
  },
  computed: {
    initial() {
      let initialData = {};
      if (this.mode == "edit") {
        initialData = {
          asal_univ: this.collectedData.dokumen.asal_univ,
          bank: this.collectedData.dokumen.bank,
          no_bpjs: this.collectedData.dokumen.no_bpjs,
          no_ijazah: this.collectedData.dokumen.no_ijazah,
          no_npwp: this.collectedData.dokumen.no_npwp,
          no_rekening: this.collectedData.dokumen.no_rekening,
          no_tenagakerja: this.collectedData.dokumen.no_tenagakerja,
          pendidikan_terakhir: this.collectedData.dokumen.pendidikan_terakhir,
          tahun_lulus: this.collectedData.dokumen.tahun_lulus
        };
      }
      return initialData;
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  activated() {
    let existSekolah = this.form.getFieldValue("sekolah")
    if(existSekolah) {
      this.$nextTick(() => {
        this.form.validateFields(['sekolah'], { force: true });
      });
    }
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("createKaryawan", values);
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file");
      } else {
        this.document = [file];
        return false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    selectSekolah(params){
      this.$nextTick(() => {
        let selectedItems = _.filter(this.datamaster.sekolah, (obj) => obj.id_sekolah==params)
        this.form.setFieldsValue({
          sekolah: params,
          alamat: selectedItems.length>0 ? selectedItems[0].alamat : "",
          noTelp: selectedItems.length>0 ? selectedItems[0].no_telp : "",
        })
      })
    },
    validateSekolah(rule, value, callback) {
      if(typeof value === 'object'){
        value = value[value.length-1]
      }
      let selectedItems = _.filter(this.datamaster.sekolah, (obj) => obj.id_sekolah==value)
      if(value && selectedItems.length>0){
        this.isDisabledAlamatNoTelp = true
      }else{
        this.isDisabledAlamatNoTelp = false
      }
      if(value) this.form.sekolah = value
      if (value && value!='') {
        callback();
      } else {
        callback(new Error("sekolah is required!"));
      }
    },
  },
};
</script>

<style>
</style>